export {default as About} from "./About/About"
export {default as Footer} from "./Footer/Footer"
export {default as Header} from "./Header/Header"
export {default as Skills} from "./Skills/Skills"
export {default as Testimonial} from "./Testimonial/Testimonial"
export {default as Work} from "./Work/Work"
